import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";

import CreatePasswordForm from "modules/auth/create-password-form";
import Actions from "modules/auth/auth-actions";

class CreatePasswordPage extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    email: PropTypes.string
  };

  render() {
    const { onSubmit, email } = this.props;
    return (
      <Fragment>
        <h2 className="sub-heading">
          <FormattedMessage id="sign-up.create-password.header" />
        </h2>
        <CreatePasswordForm onSubmit={onSubmit} initialValues={{ email }} />
      </Fragment>
    );
  }
}

const mapDispatchToProps = {
  onSubmit: Actions.Creators.passwordCreated
};

export default connect(
  null,
  mapDispatchToProps
)(CreatePasswordPage);



// WEBPACK FOOTER //
// ./src/modules/auth/create-password-page.js